import { IconBolt, IconX } from './Icon';

interface Props {
  count: number;
  onClear: () => void;
  onTrigger: () => void;
  busy?: boolean;
}

export function SelectionBar({ count, onClear, onTrigger, busy }: Props) {
  if (count === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-40 flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-3 rounded-full border border-[var(--color-border-strong)] bg-[var(--color-surface)]/95 px-2 py-1.5 shadow-2xl shadow-black/40 backdrop-blur">
        <button
          onClick={onClear}
          aria-label="Clear selection"
          className="rounded-full p-1.5 text-[var(--color-text-dim)] hover:bg-[var(--color-surface-2)] hover:text-zinc-100"
        >
          <IconX />
        </button>
        <span className="text-sm tabular-nums text-zinc-200">
          <strong className="font-semibold">{count}</strong> selected
        </span>
        <span className="h-5 w-px bg-[var(--color-border-strong)]" />
        <button
          onClick={onTrigger}
          disabled={busy}
          className="btn-primary !rounded-full !px-3.5"
        >
          <IconBolt width={14} height={14} />
          {busy ? 'queuing…' : 'warm now'}
        </button>
      </div>
    </div>
  );
}
